/**
 * Verifica se o conteúdo do editor está vazio.
 *
 * @param {string} [html=''] - O conteúdo HTML a ser verificado.
 * @returns {boolean} Retorna `true` se o conteúdo estiver vazio ou for inválido, e `false` caso contrário.
 */
function verifyContentOfEditorIsEmpty(html = '') {
  const { stripHtml } = stringStripHtml;

  if (typeof html !== 'string') {
    return true;
  }

  if (html.includes('grupoa')) {
    return false;
  }

  const regexGetAllWhiteSpaces = /[\s\u00A0]|&nbsp;|&#xA0;/gi;
  const htmlWithoutTags = stripHtml(html).result;

  return !(htmlWithoutTags.replace(regexGetAllWhiteSpaces, '').trim());
}

/**
 * Remove tags HTML de uma string e retorna o texto limpo e normalizado, limitado a um tamanho máximo.
 *
 * @param {string} value - A string contendo HTML a ser processada.
 * @returns {string} O texto limpo, normalizado e limitado ao tamanho máximo.
 */
function getHTMLPlainText(value) {
  const stripedString = window.stringStripHtml?.stripHtml(value);
  if (!stripedString) {
    return '';
  }

  const LINE_BREAK_REGEX = /\r?\n|\r/g;
  const MAX_PREVIEW_LENGTH = 500;
  const cleaned = stripedString.result
    .normalize('NFD')
    .replace(LINE_BREAK_REGEX, ' ')
    .replace(' / ', '/')
    .slice(0, MAX_PREVIEW_LENGTH);

  return cleaned.trim();
}

/**
 * Verifica se uma string é texto puro, sem HTML.
 *
 * @param {string} str - A string a ser verificada.
 * @returns {boolean} Retorna `true` se a string for texto puro, e `false` caso contrário.
 */
function isPlainText(str) {
  const div = document.createElement('div');
  div.innerHTML = str;
  return div.textContent === str;
}

/**
 * Converte texto puro em HTML, encapsulando em uma tag especificada
 * substituindo `scape sequences` por seus respectivos valores.
 *
 * @param {string} str - O texto puro a ser convertido.
 * @param {boolean} [encapsulateNewLines=false] - Se true, encapsula cada linha em uma tag separada.
 * @param {string} [tag='p'] - A tag HTML usada para encapsular o texto.
 * @returns {string} O texto convertido em HTML.
 */
function plainTextToHtml(str, encapsulateNewLines = false, tag = 'p') {
  let content = str
    .replaceAll('\n', '<br>')
    .replaceAll('\t', '&nbsp;&nbsp;&nbsp;&nbsp;')
    .replaceAll('  ', '&nbsp;&nbsp;');

  if (encapsulateNewLines) {
    content = content.replaceAll('<br>', `</${tag}><${tag}>`);
  }

  return `<${tag}>${content}</${tag}>`;
}

module.exports = {
  verifyContentOfEditorIsEmpty,
  getHTMLPlainText,
  isPlainText,
  plainTextToHtml
};
